import { TextBoxMultipleIcon } from './TextBoxMultipleIcon';

/**
 * author: Michael Irigoyen
 * id 3F7FCD03-4E12-4D4D-AB63-C8D51F938284
 * name text-box-multiple
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/text-box-multiple.svg
 * tags
 * - Files / Folders 
 */
export const FileDocumentBoxMultipleIcon = TextBoxMultipleIcon;
export default FileDocumentBoxMultipleIcon